import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, switchMap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiEndpoint } from 'src/app/config/endpoints';
import { AppSettings } from 'src/app/config/general.config';

@Injectable({
  providedIn: 'root'
})
export class ResourceClientService {

  private baseUrl = environment.apiUrl + ApiEndpoint.ResourceController;

  constructor(private http: HttpClient) { }

  getFile(payload: any = {}) {
    return this.http.post(`${this.baseUrl}/Get`, payload, {
      headers: this.buildResourceHeaders()
    });
  }

  /** Uploads a file and returns the response holding the stored file URL. */
  upload(data: FormData): Observable<any> {
    return this.http.post(`${this.baseUrl}/Upload`, data, {
      headers: this.buildResourceHeaders()
    });
  }

  download(fileName: string): Observable<Blob> {
    return this.http.get(
      `${this.baseUrl}/GetFile?fileName=${encodeURIComponent(fileName)}`,
      {
        headers: this.buildResourceHeaders(),
        responseType: 'blob'
      }
    );
  }

  /** Downloads a stored image and returns it as a base64 data URL, ready to bind to an <img src>. */
  fetchProfilePicture(fileName: string): Observable<string> {
    return this.download(fileName).pipe(
      switchMap(blob => this.toDataUrl(blob))
    );
  }

  private toDataUrl(blob: Blob): Observable<string> {
    return new Observable<string>(observer => {
      const reader = new FileReader();

      reader.onload = () => {
        observer.next(reader.result as string);
        observer.complete();
      };

      reader.onerror = () => observer.error(reader.error);

      reader.readAsDataURL(blob);

      return () => reader.abort();
    });
  }

  private buildResourceHeaders(): HttpHeaders {
    return new HttpHeaders()
      .set('AppType', AppSettings.AppType)
      .set('ResourceClientId', AppSettings.ResourceClientId);
  }
}
